import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-echarts-header" }
const _hoisted_2 = { class: "home-echarts-header__title" }
const _hoisted_3 = { class: "home-echarts-header__controls" }

import { ref, reactive, onBeforeMount, inject } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import { getCurrentMonthDateRange } from '@/utils/timeFormat'
import CosRangePickerMonth from '@/components/CosRangePickerMonth/index.vue'
import { zbuCluePutCondition } from '@/api/marketing/index'
import type { Ref, PropType } from 'vue'

const __default__ = { name: 'LeadDeliveryEchart' }

interface ItemType {
  pushCount: number
  dateTime: string
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '437px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {

enum Subdomain {
  Fbu = 'fbu',
  Lbu = 'lbu'
}
const subdomain = inject<Subdomain>('subdomain')

const props = __props

const spinning = ref(false)
const showECharts = ref(false)
const { currentDayOfMonth } = getCurrentMonthDateRange()
const queryForm = reactive({
  countDate: currentDayOfMonth
})
const getData = () => {
  spinning.value = true
  const params = { countDate: queryForm.countDate.split(' ')[0] }
  zbuCluePutCondition(params)
    .then((res) => {
      const data = res.data as unknown as ItemType[]
      if (data.length === 0) {
        showECharts.value = false
        initChart([])
      } else {
        showECharts.value = true
        initChart(data)
      }
    })
    .finally(() => {
      spinning.value = false
    })
}

const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>)
const initChart = (data: ItemType[]) => {
  setOptions({
    tooltip: {
      trigger: 'axis'
    },
    toolbox: {
      feature: {
        magicType: {
          show: false,
          type: ['line', 'bar']
        }
      }
    },
    grid: {
      left: '80',
      right: '50'
    },
    calculable: false,
    xAxis: [
      {
        type: 'category',
        data: data.map((item) => item.dateTime),
        axisLabel: {
          // 倾斜的程度
          formatter: function (value: any) {
            if (value.length > 7) {
              return `${value.slice(0, 7)}...`
            }
            return value
          }
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: {
            type: 'dashed'
          }
        },
        axisLabel: {
          // 倾斜的程度
          margin: 2,
          formatter: function (value: any) {
            if (value >= 10000 && value < 100000000) {
              value = value / 10000 + '万'
            } else if (value >= 100000000 && value < 1000000000000) {
              value = value / 100000000 + '亿'
            } else if (value >= 1000000000000) {
              value = value / 1000000000000 + '兆'
            }
            return value
          }
        },
        splitLine: {
          lineStyle: {
            type: 'dashed'
          }
        }
      }
    ],
    series: [
      {
        name: '线索投放',
        type: 'line',
        itemStyle: {
          color: subdomain === Subdomain.Lbu ? '#FFB648' : '#3F97FF'
        },
        data: data.map((item) => item.pushCount)
      }
    ]
  })
}
onBeforeMount(getData)

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CosRangePickerMonth, {
          style: {"width":"220px"},
          startTime: queryForm.countDate,
          "onUpdate:startTime": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.countDate) = $event)),
          allowClear: props.allowClear,
          onChange: getData
        }, null, 8, ["startTime", "allowClear"])
      ])
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})